import { useActiveBranch } from '@/features/auth/hooks/use-active-branch';
import { cn } from '@/shared/lib/cn';

export function BranchIndicator() {
  const { branchName, branchCode, isSwitchingBranch } = useActiveBranch();

  if (!branchCode) return null;

  return (
    <div
      className={cn(
        'hidden min-w-0 flex-1 rounded-lg border border-white/20 px-2.5 py-1.5 sm:block xl:w-44 xl:flex-none 2xl:w-56',
        isSwitchingBranch && 'opacity-70',
      )}
    >
      {branchName && (
        <p className="whitespace-normal break-words text-sm font-medium leading-tight text-white">{branchName}</p>
      )}
      <p className="truncate font-mono text-[10px] text-white">{branchCode}</p>
    </div>
  );
}
